import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/general-stats', component: FuseLoadable({ loader: () => import('./GeneralStatsApp') }) }] };

export default [Index];
